
import request from "@/services/axios";
import { url } from "@/services/api";
// const url = "http://192.168.88.140:15001"

export default {
    // 在线表单信息分页查询
    getToolOnlHeadList(params) {
        return request({
            url: url + '/tool/onl/headList',
            method: 'get',
            params: params
        })
    },
    // 在线表单字段信息列表
    getToolOnlFieldList(params) {
        return request({
            url: url + '/tool/onl/fieldList/' + params.headId,
            method: 'get',
        })
    },
    // 新增在线表单信息
    AddToolOnl(data) {
        return request({
            url: url + '/tool/onl/insert',
            method: 'post',
            data: data
        })
    },
    // 修改在线表单信息
    UpdateToolOnl(data) {
        return request({
            url: url + '/tool/onl/update',
            method: 'post',
            data: data
        })
    },
    // 在线表单信息列表
    getQueryHeadInfo(params) {
        return request({
            url: url + '/tool/onl/queryHeadInfo',
            method: 'get',
            params: params
        })
    },
}